import { LargeSegmentedControl, SegmentedControlOption } from 'ui/segmentedControl';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';

import { SubHeader, SubHeaderActions } from '../components/SubHeader';
import { DebouncedSearchInput } from '../components/DebouncedSearchInput';
import { useFieldsFilterContext } from './filter';

const displayContent = {
  pageTitle: 'User fields',
  searchPlaceholder: 'Search all fields',
};

const options: SegmentedControlOption[] = [
  { name: 'Expand All', value: 'expand' },
  { name: 'Collapse All', value: 'collapse' },
];

const PageActions = () => {
  const { search, changeSearch } = useFieldsFilterContext();
  const { collapse, expand, mode } = useExpansionContext();

  const handleSelect = (value: string) => {
    if (value === 'expand') {
      expand();
    } else if (value === 'collapse') {
      collapse();
    }
  };

  const selectedValue =
    mode === ExpandModes.collapse || mode === ExpandModes.expand ? mode : undefined;

  return (
    <SubHeaderActions>
      <LargeSegmentedControl options={options} onSelect={handleSelect} value={selectedValue} />
      <DebouncedSearchInput
        id="event-history-search"
        placeholder={displayContent.searchPlaceholder}
        value={search}
        onChange={changeSearch}
      />
    </SubHeaderActions>
  );
};

export const ProfileFieldsHeader = () => (
  <SubHeader actions={<PageActions />}>{displayContent.pageTitle}</SubHeader>
);
